export const buildInfo: { gitHash: string; dateTime: number | 'local' } = { gitHash: '8c1ea60', dateTime: 1785448017382 };